import { ViewModel,View, ObservableArray } from "binder"
import { BooleanType, ChartSeriesType, ClassType, DateType, FloatType, IntegerType, IPropertyTypeVisitor, KnownClassType, ListType, PropertyType, ServerSideDataLoaderType, StringType, VoidType } from "../../structure";
import { DataModelClass, GetAllClassesMessage, GetAllPropertyTypesMessage } from "../dataModelBuilder-viewModel";
import  { TypeSelectorView } from "./typeSelector-view"

interface ITypePartSelector{
    setGenericType(type: any): void;
    getSelectedType():any;
    setPropertyType(propertyType:PropertyType);
}

export class TypeSelectorViewModel extends ViewModel implements ITypePartSelector{
    constructor(parentViewModel: ViewModel,allowVoid:boolean=false) {
        super(parentViewModel);

        this.validTypes = ObservableArray.create<propertyTypes>();
        this.loadTypes(allowVoid);
        this.genericTypeSelector = new EmptyTypeSelector(this);
    }
    GetDefaultView(): View <ViewModel> {
        return new TypeSelectorView();
    }
    public getTypeId(): string {
        return "VM-1A7C53D3-7922-4684-8457-B923B7520EAB"
    }

    public set validTypes(v: ObservableArray<propertyTypes>) { this._validTypes = v; } public get validTypes(): ObservableArray<propertyTypes> { return this._validTypes;} private _validTypes: ObservableArray<propertyTypes>;
    public set selectedType(v: propertyTypes) { 
        this._selectedType = v; 
        if(v){
            this.genericTypeSelector = new GenericTypeSelectorFactory().getTypeSelector(v.propertyType,this);
            if(this.onSelectedTypeChanged){
                this.onSelectedTypeChanged(v.propertyType);
            }
        }
        else{
            if(this.onSelectedTypeChanged){
                this.genericTypeSelector = new EmptyTypeSelector(this);    
                this.onSelectedTypeChanged(null);
            }
        }
    } public get selectedType(): propertyTypes { return this._selectedType;} private _selectedType: propertyTypes;
    public set genericTypeSelector(v: ITypePartSelector) { this._genericTypeSelector = v; } public get genericTypeSelector(): ITypePartSelector { return this._genericTypeSelector;} private _genericTypeSelector: ITypePartSelector;
    
    private loadTypes(allowVoid:boolean){
        let msg = new GetAllPropertyTypesMessage();
        msg.allowVoid = allowVoid;
        this.handleMessage(msg);
        this.validTypes.update(...msg.types.map(x=>{
            let r = new propertyTypes(this);
            r.propertyType = x;
            return r;
        }));
    }
    
    getSelectedType() :PropertyType {
        let basePropertyType = this.selectedType.propertyType;
        let genericType = this.genericTypeSelector.getSelectedType();
        basePropertyType.setGenericParameter(genericType);
        return basePropertyType;
    }
    verify() : string[] {
        let result = [];
        if(this.selectedType==null){
            result.push('Type is not specified.');
        }else if(this.genericTypeSelector==null){
            result.push('Type is not specified.');   
        }else{
            let type ;
            try{
                type = this.getSelectedType();
            }catch{
                type = this.selectedType.propertyType;
            }
            if(type==null){
                result.push('Type is not specified.');
            }else {
                result.push(...type.verify());
            }
    
        }
        return result;
    }
    
    setPropertyType(type: PropertyType) {
        if(type==null){
            this.selectedType = null;
            return;
        }
        this.selectedType = this.validTypes.filter(x=>x.propertyType.isSameTypeAs(type))[0];
        let genericType = new GenericTypeResolver().getGenericType(type);
        this.setGenericType(genericType);
    }
    setGenericType(genericType: any): void{
        this.genericTypeSelector.setPropertyType(genericType);
    }

    public onSelectedTypeChanged : (x:PropertyType)=>void;
}


export class propertyTypes extends ViewModel implements IPropertyTypeVisitor{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    visitChartSeriesType(arg0: ChartSeriesType, parameter: any) {
        this.name = "ChartSeriesType";
    }
    visitVoidType(arg0: VoidType, parameter: any) {
        this.name = "Void";
    }
    visitBooleanType(arg0: BooleanType, parameter: any) {
        this.name = "Boolean";
    }
    visitIntegerType(arg0: IntegerType, parameter: any) {
        this.name = "Integer";
    }
    visitFloatType(arg0: FloatType, parameter: any) {
        this.name = "Float";
    }
    visitStringType(arg0: StringType, parameter: any) {
        this.name = "String";
    }
    visitListType(arg0: ListType, parameter: any) {
        this.name = "List";
    }
    visitClassType(arg0: ClassType, parameter: any) {
        this.name = "Class";
    }
    visitKnownClassType(arg0: KnownClassType, parameter: any) {
        this.name = "KnownClass";
    }
    visitServerSideDataLoaderType(arg0: ServerSideDataLoaderType, parameter: any) {
        this.name = "ServerSideDataLoader";
    }
    visitDateType(arg0: DateType, parameter: any) {
        this.name = "DateTime";
    }

    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set propertyType(v: PropertyType) { 
        this._propertyType = v; 
        if(v){
            v.Accept(this,null);
        }
    } public get propertyType(): PropertyType { return this._propertyType;} private _propertyType: PropertyType;
}

export class ClassTypeSelector extends ViewModel implements ITypePartSelector{
    public getTypeId(): string {return 'classes';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.classes = ObservableArray.create<DataModelClass>();

        this.loadClasses();
    }
    setPropertyType(propertyType: KnownClassType) {
        this.setGenericType(propertyType);
    }
    getSelectedType() {
        return this.selectedClass;
    }
    
    public set classes(v: ObservableArray<DataModelClass>) { this._classes = v; } public get classes(): ObservableArray<DataModelClass> { return this._classes;} private _classes: ObservableArray<DataModelClass>;
    public set selectedClass(v: DataModelClass) { this._selectedClass = v; } public get selectedClass(): DataModelClass { return this._selectedClass;} private _selectedClass: DataModelClass;
    
    loadClasses(){
        let msg = new GetAllClassesMessage();
        this.handleMessage(msg);
        this.classes.update(...msg.classes);
    }

    setGenericType(type: any): void {
        if(type==null){
            this.selectedClass = null;
            return;
        }
        let foundClasses = this.classes.filter(x=>x.name==type.name);
        if(foundClasses.length==0){
            this.selectedClass = null;
            return;
        }
        this.selectedClass = foundClasses[0];
    }

}

export class EmptyTypeSelector extends ViewModel implements ITypePartSelector{
    public getTypeId(): string {return 'empty';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    getSelectedType() {
        return null;
    }
    setGenericType(type: any): void {
    }
    setPropertyType(propertyType:PropertyType){
        
    }

    
}

class GenericTypeSelectorFactory implements IPropertyTypeVisitor{
    private parent:ViewModel;
    public getTypeSelector(type:PropertyType,parent:ViewModel):ITypePartSelector{
        this.parent = parent;
        return type.Accept(this,null);
    }
    
    visitVoidType(arg0: VoidType, parameter: any) {
        return new EmptyTypeSelector(this.parent);
    }
    
    visitBooleanType(arg0: BooleanType, parameter: any) {
        return new EmptyTypeSelector(this.parent);
    }
    visitIntegerType(arg0: IntegerType, parameter: any) {
        return new EmptyTypeSelector(this.parent);
    }
    visitFloatType(arg0: FloatType, parameter: any) {
        return new EmptyTypeSelector(this.parent);
    }
    visitDateType(arg0: DateType, parameter: any) {
        return new EmptyTypeSelector(this.parent);
    }
    visitChartSeriesType(arg0: ChartSeriesType, parameter: any) {
        return new EmptyTypeSelector(this.parent);
    }
    visitStringType(arg0: StringType, parameter: any) {
        return new EmptyTypeSelector(this.parent);
    }
    visitListType(arg0: ListType, parameter: any) {
        return new TypeSelectorViewModel(this.parent);
    }
    visitClassType(arg0: ClassType, parameter: any) {
        return new EmptyTypeSelector(this.parent);
    }
    visitKnownClassType(arg0: KnownClassType, parameter: any) {
        return new ClassTypeSelector(this.parent);
    }
    visitServerSideDataLoaderType(arg0: ServerSideDataLoaderType, parameter: any) {
        return new EmptyTypeSelector(this.parent);
    }
    
}

class GenericTypeResolver implements IPropertyTypeVisitor{
    visitDateType(arg0: DateType, parameter: any) {
        return null;
    }
    visitChartSeriesType(arg0: ChartSeriesType, parameter: any) {
        return null;
    }
    visitServerSideDataLoaderType(arg0: ServerSideDataLoaderType, parameter: any) {
        return null;
    }
    visitVoidType(arg0: VoidType, parameter: any) {
        return null;
    }
    getGenericType(type:PropertyType):PropertyType{
        return type.Accept(this,null);
    }
    visitBooleanType(arg0: BooleanType, parameter: any) {
        return null;
    }
    visitIntegerType(arg0: IntegerType, parameter: any) {
        return null;

    }
    visitFloatType(arg0: FloatType, parameter: any) {
        return null;

    }
    visitStringType(arg0: StringType, parameter: any) {
        return null;

    }
    visitListType(arg0: ListType, parameter: any) {
        return arg0.OfType;
    }
    visitClassType(arg0: ClassType, parameter: any) {
        return null;
    }
    visitKnownClassType(arg0: KnownClassType, parameter: any) {
        return arg0.ForClass;
    }

}


